export const momentFormat = {
  datetime: "YYYY-MM-DD HH:mm",
  datetimeWithDay: "YYYY-MM-DD HH:mm (dddd)",
  date: "YYYY-MM-DD",
  dateWithDay: "YYYY-MM-DD dddd",
  yearMonth: "YYYY-MM",
  dateFormatMonthCN: "YYYY年MM月",
  dateFormatDayCN: "YYYY年MM月DD日",
  dateFormatDetailCN: "YYYY年MM月DD日 HH:mm",
  dateFormatDetailWithWeek: "YYYY年MM月DD日 HH:mm ddd",
  timeWithWeek: "HH:mm（ddd）",
  dateFormatMonthDetailCN: "MM月DD日 HH:mm",
  dateFormatDay: "YYYY-MM-DD",
  dateFormatDaySlant: "YYYY/MM/DD",
  dateFormatDaySlantDetail: "YYYY/MM/DD HH:mm:ss",
  time: 'HH:mm',
  datetimeLog: "YYYY-MM-DD HH:mm:ss.SSS",
  shortDate: "MM月DD日", //4月23日
  yearFormat: "YYYY",
  monthFormat: "MM",
  dateTimeDetail: "YYYY-MM-DD HH:mm:ss",
  defaultTimeZone: 'Asia/Shanghai',
};

export const commonConfig = {
  switchScreenWidth: 768,
  loginType: {
    ANONYMOUS: 'ANONYMOUS',  // 匿名
    REALNAME: 'REALNAME',  // 实名
    PWDFREE: 'PWDFREE',  // 免密登录
    AD: 'AD', // 统一认证登录
  },

  wxwork: "wxwork",
  weChat: "WeChat",
  weichai: "weichai",

  // 会议状态： 未开始 即将开始 会议中 已结束 审核中 已取消
  meetingStatus: {
    NOTSTART: 'NOTSTART',
    GOINGTOSTART: 'GOINGTOSTART',
    MEETING: 'MEETING',
    END: 'END',
    UNDERREVIEW: 'UNDERREVIEW',
    RELEASED: 'RELEASED',
    CANCELED: 'CANCELED',
  },
  // btn 根据不同状态渲染样式
  statusStyle: {
    NOTSTART: 'success',
    GOINGTOSTART: 'warning',
    MEETING: 'primary',
    END: 'default',
    RELEASED: 'default',
    UNDERREVIEW: 'alert',
    CANCELED: 'danger',
  },
  // 分状态 预约阶段、普通阶段、签到、结束
  preStatus: ["NOTSTART", "GOINGTOSTART"],
  normalStatus: ["NOTSTART", "GOINGTOSTART", "MEETING"],
  checkinStatus: ["GOINGTOSTART", "MEETING"],
  endedStatus: ["END", "CANCELED", "RELEASED"],
  statusSort: {
    MEETING: 3,
    GOINGTOSTART: 2,
    NOTSTART: 1,
    UNDERREVIEW: 0,
    END: -1,
    RELEASED: -1,
    CANCELED: -2,
  },
  startHour: 8,  // 会议的默认开始时间（小时）
  unitSlotMinute: 30,  // 会议timeSlot的单元分钟
  timeReverseSort: {sort: {createdAt: -1}},
  // 会议模式
  meetingModes: {
    offline: "线下",
    online: "线上",
    onAndOff: "综合",
  },
  checkinTypes: {  // 签到方式
    scanCode: "扫码签到",
    faceSwiping: "人脸识别签到",
    cardSwiping: "刷卡签到",
    thirdParty: "第三方签到",  // 通过接口签到
    manuallyInput: "后台补录" // 后台手动录入
  },
  // 周期会议频率
  periodicTypes: {
    daily: {label: "每天", value: "daily"},
    weekdays: {label: "每个工作日", value: "weekdays"},
    weekly: {label: "每周", value: "weekly"},
    fortnightly: {label: "每两周", value: "fortnightly"},
    monthly: {label: "每月", value: "monthly"},
    custom: {label: "自选时间", value: "custom"},
  },
  // 预约途径
  reserveWays: {
    pc: {label: "PC端预约", value: "pc"},
    mobile: {label: "移动端预约", value: "mobile"},
    scanCode: {label: "扫码快速预约", value: "scanCode"},
    import: {label: "导入", value: "import"},
    thirdParty: {label: "接口预约", value: "thirdParty"}
  },
  meetingModesFilter: {
    offline: {label: "线下", value: "offline"},
    online: {label: "线上", value: "online"},
    onAndOff: {label: "综合", value: "onAndOff"},
  },
  meetingStatusFilter: {
    UNDERREVIEW: {label: "审核中", value: "UNDERREVIEW"},
    END: {label: "已结束", value: "END"},
    RELEASED: {label: "已释放", value: "RELEASED"},
    CANCELED: {label: "已取消", value: "CANCELED"},
  },
  commonlyUsedCdt: {
    matchDeptRooms: {label: "本部门会议室", value: "matchDeptRooms"},
  },
  // 人数筛选选择器
  capacityChoices: {
    none: {label: "不限", value: 0},
    small: {label: "10人以下", value: 1, max: 10},
    middle: {label: "10-20 人", value: 2, min: 10, max: 20},
    large: {label: "20人以上", value: 3, min: 20},
  },
  // 审核方式
  reviewModes: {
    NONE: {label: "不需审核", value: "NONE"},
    INNER: {label: "内部审核", value: "INNER"},
    OUTER: {label: "外部审核", value: "OUTER"},
  },

  weekInfo: {
    1: "一",
    2: "二",
    3: "三",
    4: "四",
    5: "五",
    6: "六",
    0: "日",
  },

  stepSlots: {
    min: 18,  // 9:00
    max: 43,  // 21:30 => 不显示
  },
  // 默认范围
  slotRange: {
    minSlot: 0,
    maxSlot: 47
  },

  backModes: {
    func: "func",  // 反馈函数处理
    route: "route",  // 传入跳转路径和参数
    static: "static",  // 静态固定的返回路径
  },

  pathMap: {
    "/admin": "/admin",
    "/front": "/mob",
    "/control": "/control",
  },

  endNoticeChoices: {
    0: "不提醒",
    15: "结束前15分钟",
    30: "结束前30分钟",
  },

  telReg: /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/,   // 手机号码正则匹配式
  emailReg: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,  // 邮箱正则匹配式
  // numLetterReg: /^[A-Za-z0-9]+$/,
  numLetterReg: /^[0-9]{6,}$/,
  frLenNumReg: /^[0-9]{4}$/,  // 4位数字
  asteriskReg: /^\*[\*]+?\*$/,

  permitsMap: {
    periodicReserve: "periodicReserve",  // 周期预约
    sponsor: "sponsor",  // 主持人
    initiator: "initiator",  // 发起人
    numberOfPeople: "numberOfPeople",  // 参会人数
    outsideParticipant: "outsideParticipant",  // 外部参会人
    copyTo: "copyTo",  // 抄送人
    participantSeats: "participantSeats",  // 参会人排座
    customerAttendance: "customerAttendance",  // 是否有客户参会
    branchVenues: "branchVenues",  // 是否需要分会场
    serviceRequire: "serviceRequire",  // 服务需求预约
    serviceCall: "serviceCall",  // 会中服务
    deviceRepair: "deviceRepair",  // 设备报修
    deviceCtrl: "deviceCtrl",  // 设备控制
    clickJoinMeeting: "clickJoinMeeting",  // 会议室入会
    checkinUnlock: "checkinUnlock",  // 会议室开锁
    meetingSubs: "meetingSubs",  // 会议订阅
    mobNav: "mobNav", //导航栏配置
    roomSubs: "roomSubs",  // 房间订阅
    roomList: "roomList",  // 会议室列表
    directReserve: "directReserve",  // 快速预约
    meetingType: "meetingType", // 会议类别
    meetingCost: "meetingCost", // 会议费用
    meetingGrade: "meetingGrade", //会议级别
    timeRange: "timeRange",  // 会议时段
    userPanel: "userPanel",  // 个人中心
    logout: "logout",  // 退出登录
  },
  // 会议详情的控制按钮
  mtBtnMap: {
    cancelMt: "取消会议",
    endMt: "结束会议",
    editMt: "编辑会议",
    delayMt: "快速延迟",
    copyMt: "再约一场",
    createOther: "组织会议",
    shareLvc: "分享直播",
    organizeMeetings: "组织会议",

    clickJoinMeeting: "会议室入会",
    checkinUnlock: "会议室开锁",
    serviceCall: "会中服务",
    deviceRepair: "设备报修",
    deviceCtrl: "设备控制",
    startLvc: "开启直播",
    endLvc: "结束直播",

    accept: "接受参会",
    undetermined: "待定",
    reject: "拒绝"
  },

  // 扩展字段相关配置
  extFields: {
    valTypes: {
      string: "string",
      number: "number",
      boolean: "boolean",
      other: "other",
    },
    setTypes: {
      normal: "normal",
      textarea: "textarea",
      structure: "structure",
      inputNumber: "inputNumber",
      tip: "tip",
    },
  },
  roomSupportPrompt: "当前时间提交会议无法及时提供会务支持",

  optSources: {
    web: "web",
    app: "app",
  },
};

// 其余视频会议厂商相关
export const tlcConfig = {
  manufacturers: {
    zoom: "zoom",
    tencent: "tencent",
    huaweiCloud: "huaweiCloud",
    xyLink: "xyLink",
    customTlc: "customTlc",
  },

  waitingRoomKeyMap: {
    zoom: "waiting_room",
    tencent: "auto_in_waiting_room",
  },
  hasCtrlPwd: {  // 主持人密码
    xyLink: true,
  },
  settingLabel: {
    zoom: {
      "join_before_host": "允许在主持人入会前加入",
      "host_video": "主持人加入会议时打开视频",
      "participant_video": "参会人加入会议时打开视频",
      "mute_upon_entry": "加入会议时静音",
    },
    tencent: {
      "allow_in_before_host": "允许在主持人入会前加入",
      "allow_unmute_self": "允许参会人取消静音",
      // "host_video": "主持人加入会议时打开视频",  // 暂不支持
      // "participant_video": "参会人加入会议时打开视频",  // 暂不支持
      "mute_enable_join": "加入会议时静音",
      "allow_screen_shared_watermark": "开启屏幕共享水印",
      "only_enterprise_user_allowed": "仅企业内部用户可入会",
    },
  },
  dftSetting: {
    zoom: {
      "host_video": false,
      "participant_video": false,
      "join_before_host": true,
      "mute_upon_entry": false,
      "waiting_room": false,
    },
    tencent: {
      "allow_in_before_host": true,
      "mute_enable_join": false,
      "allow_unmute_self": true,  // 允许参会者取消静音
      // "host_video": false,
      // "participant_video": false,
      "only_enterprise_user_allowed": false,
      "auto_in_waiting_room": false,
      "allow_screen_shared_watermark": true,
    },
  },
  liveConferenceMF: {
    xyLink: "lexiang",
  },

  invitation: {
    zoom: {
      title: "ZOOM",
      detail: "在PC、Mac、iPhone/iPad、安卓手机/平板上点击上述链接即可加入会议。"
    },
    huaweiCloud: {
      title: "华为云",
      detail: "您可单击会议链接入会或者使用会议ID在华为云会议客户端、华为云会议管理平台、会议硬件终端入会。"
    },
    tencent: {
      title: "腾讯",
      detail: "您可点击会议链接入会或者使用会议ID在腾讯会议客户端加入会议。"
    },
    xyLink: {
      title: "小鱼",
      detail: "您可点击会议链接入会或者使用会议ID在小鱼易连客户端加入会议。"
    }
  },

  pwdCheckReg: {
    xyLink: {
      reg: /^[0-9]{6}$/,
      msg: '密码为6位数字！'
    },
    tencent: {
      reg: /^[0-9]{6}$/,
      msg: '密码为6位数字！'
    }
  }
};

export const formTitleCfg = {
  outsideParticipant: {
    name: "姓名",
    tel: "手机号码",
    company: "所属公司",
    email: "邮箱",
    position: "职位",
    licensePlateNumber: "车牌号",
  },
  basicTitles: {
    "subject": "会议主题",
    "meetingTime": "会议日期",
    "meetingRoom": "会议室",
    "reviewProcess": "审批流程",
    "insideParticipant": "参会人",
    "outsideParticipant": "外部参会人",
    // "participantSeats": "参会人排座",
    "numberOfPeople": "参会人数",
    "initiator": "发起人",
    "sponsor": "主持人",
    "copyTo": "抄送人",
    "createdBy": "预约人",
    "periodicReserve": "周期性会议",
    "branchVenues": "分会场",
    "customerAttendance": "是否有客户参会",
    "serviceRequire": "会议服务需求",
    "teleconference": "是否视频会议",
    "liveConference": "是否开启直播",
    // 会议属性
    "meetingGrade": "会议级别",
    "timeRange": "会议时段",
    "meetingCost": "会议费用",
    // 会中相关
    "serviceCall": "会中服务",
    "deviceRepair": "设备报修",
    "deviceCtrl": "设备控制",
    "clickJoinMeeting": "会议室入会",
    "checkinUnlock": "会议室开锁",
    "startLvc": "开启直播",
    "endLvc": "结束直播"
  },
};

export const commonIcons = {
  titles: {
    "subject": "icon-huati",
    "meetingTime": "icon-shijian",
    "periodicReserve": "icon-rili",
    "meetingRoom": "icon-dingwei",
    "reviewProcess": "icon-shu",
    "isRowSeat": "icon-zuoxi",
    "teleconference": "icon-shipin",
    "liveConference": "icon-shipinhuiyi",
    "branchVenues": "icon-shuzhuangtu",
    "numberOfPeople": "icon-qunzu",
    "insideParticipant": "icon-qunzu",
    "outsideParticipant": "icon-qunzu",
    "initiator": "icon-renyuan",
    "sponsor": "icon-renyuan",
    "copyTo": "icon-qunzu",
    "createdBy": "icon-yuyueren",
    "customerAttendance": "icon-fuwuyuan",
    "serviceRequire": "icon-qingdan",
    // 会议属性
    "meetingGrade": "icon-jibie",
    "timeRange": "icon-shiduan",
    "meetingCost": "icon-feiyong",
    /*// 会中相关
    "serviceCall": "",
    "deviceRepair": "",
    "deviceCtrl": "",
    "clickJoinMeeting": "",
    "checkinUnlock": "",
    "startLvc": "",
    "endLvc": "",
    */
    // 固定属性
    meetingNotice: "icon-tixing",
    meetingRemarks: "icon-beizhu",
    statistics: "icon-tongji",
    quantity: "icon-shuliang",
  },
};

// 服务相关
export const serviceConfig = {
  status: {
    NOTSTART: 'NOTSTART',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED',
  },
  doneStatus: ['COMPLETED', 'CANCELED'],  // 已完成，已取消
  statusStyle: {
    NOTSTART: 'warning',
    PROCESSING: 'primary',
    COMPLETED: 'success',
    CANCELED: 'default',
  },

  severityMap: {
    serious: "严重",
    commonly: "一般",
    prompt: "提示"
  },
  severityStyleMap: {
    serious: "danger",
    commonly: "primary",
    prompt: "default"
  },
};
